export default __webpack_public_path__ + "static/media/img3.f1eceb3f.png";